export default "__VITE_ASSET__CwJSL$p$__"